import Vec2 from 'vec2';

import { assignDisplayVectors } from './assignDisplayVectors';
import { calculateStartPointAdjustment } from './calculateStartPointAdjustment';
import { getCornerAndOrientationAngles } from './getCornerAndOrientationAngles';
import { getEdgeLengths } from './getEdgeLengths';
import { replaceEdgeInShape } from './replaceEdgeInShape';
import { updateCornerReplacementCoords } from './updateCornerReplacementCoords';

import { DrawingEdge, DrawingShape } from '~/core/models';

export const setEdgeStartAndEndDisplayPoints = (
  shape: DrawingShape,
  edge: DrawingEdge,
  edgeIndex: number
) => {
  const startPt = shape?.cornerMap[edge.startCornerId];
  const endPt = shape?.cornerMap[edge.endCornerId];

  if (!startPt || !endPt) {
    console.warn('null startPt or endPt', edge, shape, shape.cornerMap);

    return;
  }

  const { orientationAngle, cornerAngleInDegrees } =
    getCornerAndOrientationAngles(shape, edge, edgeIndex);

  endPt.angle = cornerAngleInDegrees;
  endPt.orientationAngle = Math.round(orientationAngle);

  const cos = Math.cos(orientationAngle * (Math.PI / 180));
  const sin = Math.sin(orientationAngle * (Math.PI / 180));

  const edgeLengths = getEdgeLengths(cos, sin, startPt, endPt);
  const {
    epX,
    epY,
    spX: initialSpX,
    spY: initialSpY,
    batAdjustStart,
  } = edgeLengths;
  const { spX, spY } = calculateStartPointAdjustment(
    startPt,
    cos,
    sin,
    batAdjustStart,
    initialSpX,
    initialSpY
  );
  // add the edge display points adjusted for corner radii or diagonals if needed
  // keep a copy in the corner for clip calcs
  const startVec = new Vec2(spX, spY);
  const endVec = new Vec2(epX, epY);

  const mutableEdge = assignDisplayVectors(edge, startVec, endVec);

  replaceEdgeInShape(shape, edge, mutableEdge);

  const currentEdge = mutableEdge !== edge ? mutableEdge : edge;

  updateCornerReplacementCoords(startPt, endPt, currentEdge);
};
